<template>
  <div style="scrollbar-width: thin;">
    <ul class='event-list'>
      <li v-for="event in filteredEvents" :key="event.timeStamp" class='event-list-item'>
        <div class="event-list-item-text" :class="{
          error: event.type === 'error'
        }">
          <div class='event-type-label'>Type: <span class='event-type'>{{event.type}}</span></div>
          <div class='event-source'>Source: {{event.source}}</div>
          <div class='event-source' v-if='event.severity'>Severity: {{event.severity}}</div>
          <div class='event-source' v-if='event.info'><span class="event-info">Info:</span> <span v-html='event.info'>{{event.info}}</span>
          </div>
        </div>

      </li>
    </ul>
  </div>

</template>

<script>
import PlayerComponent from '../PlayerComponent.vue';
import { Docs } from '../../../utils/docs';
import { stateToString } from '../../../utils/player';

function bps (bps) {
  if (bps) {
    return '@' + clpp.utils.strings.bitrateToString(bps);
  } else {
    return '';
  }
}

const extendedInfo = {
  statechanged: e => {
    return `State changed from ${stateToString(
      e.detail.previousState,
      e.detail.reason
    )} to ${stateToString(e.detail.currentState, e.detail.reason)}`;
  },
  bitratechanged: e => {
    const d = e.detail;
    return `Playing Rendition ${d.width}x${d.height}${bps(d.bandwidth)}`;
  },
  videotrackchanged: e => {
    const d = e.details;
    const reason = d.abrSelection ? 'ABR' : 'Manual';
    return `Selected Rendition ${d.width}x${d.height}${bps(d.bandwidth)}. Reason ${reason}`;
  },
  drmsessionupdate: e => {
    const toS = clpp.utils.strings.durationToString;
    const expiresInMs = e.expirationTime === Infinity ? 'Unlimited License' : 'Expires in ' + toS((e.expirationTime - Date.now()) / 1000);
    return `Selected DRM system '${e.keySystem}'. ${expiresInMs}`;
  },
  drmexpirationupdate: e => {
    const toS = clpp.utils.strings.durationToString;
    const expiresInMs = e.expirationTime === Infinity ? 'Unlimited' : toS((e.expirationTime - Date.now()) / 1000);
    return `Expires in ${expiresInMs}`;
  },
  error: e => {
    if (e && e.detail) {
      const d = e.detail;
      const docsEntry = Docs.findErrorByCode(d.code);
      if (docsEntry) {
        const desc = Docs.description(docsEntry);
        return `Error ${docsEntry.name} [Category ${d.category} - Code ${d.code}]. ${desc}`;
      }
      return `Error Category ${d.category} Code ${d.code}`;
    }
    return '';
  }
};

function getExtendedInfo (e) {
  const f = extendedInfo[e.type];
  if (f) return f(e);
  return null;
}

function getEventSource (e) {
  if (!e) return 'Unknown';
  if (e.detail instanceof Event) {
    return 'Native';
  }
  return 'clpp';
}

function getSeverity (e) {
  if (!e || !e.detail || e.detail.severity === undefined) return null;
  switch (e.detail.severity) {
    case clpp.Error.Severity.FATAL:
      return 'FATAL';
    case clpp.Error.Severity.RECOVERABLE:
      return 'RECOVERABLE';
  }
  return 'UNKNOWN';
}

export default {
  extends: PlayerComponent,
  name: 'LogViewEvents',
  props: ['events'],
  data () {
    return {
      filter: ''
    };
  },
  computed: {
    filteredEvents () {
      const mapped = this.events.map(e => {
        return {
          type: e.type,
          source: getEventSource(e),
          severity: getSeverity(e),
          api: Docs.getEvent(e.type),
          info: getExtendedInfo(e)
        };
      });
      if (!this.filter) return mapped;
      return mapped.filter(x => clpp.utils.strings.startsWith(x.type, this.filter));
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/style/color_";

  .event-view {
    color: white;
  }
  .error {
    color: $color-cl-red;
  }

  .event-list-item {

    margin-top: 10px;
    margin-bottom: 5px;

    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    border-bottom: 1px solid #999999;
  }

  .event-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .event-list::-webkit-scrollbar {
    width: 6px;
  }

  .event-list::-webkit-scrollbar-track {
    background-color: #DDDDDD;
  }

  .event-list::-webkit-scrollbar-thumb {
    /*border-radius: 10px;*/
    background-color: #999999;
  }

  .event-type {
    font-family: monospace;
    font-weight: bold;
  }

  .event-info {
    font-weight: bold;
  }

  .event-type-label,
  .event-source,
  .event-description,
  .event-type {
    font-size: 13px;
  }

  .event-list-item-text {
    width: 100%;
    margin: 0;
    overflow: hidden;
    line-height: 1.25em;
    text-overflow: ellipsis;
  }

  .event-list-item-text >>> p {
    margin: 0;
  }
</style>
